import { render } from "./RemarksDialog.vue?vue&type=template&id=28b47622&scoped=true"
import script from "./RemarksDialog.vue?vue&type=script&lang=js"
export * from "./RemarksDialog.vue?vue&type=script&lang=js"

import "./RemarksDialog.vue?vue&type=style&index=0&id=28b47622&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b47622"]])

export default __exports__